module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_intro-heading01-sp-38d38629369d454dac46c2f62cd62239.png";